angular.module('picmonicpublic').controller('PillarsController', ['$scope', function($scope){
    $scope.seen = JSON.parse(localStorage.getItem('pillars_seen')) || {};

    $scope.num_seen = function() {
        var num = 0;
        for(var x in $scope.seen) {
            num++;
        }

        return num;
    };

    this.$onDestroy = function(){
        localStorage.setItem('pillars_seen', JSON.stringify($scope.seen));
    };

}]);